/**
 * Slot nomi avversari = partecipanti − 1 (tu resti fuori).
 * Id stabili: allunga/accorcia la lista senza riciclare id esistenti.
 */

export function opponentSlotsNeeded(numParticipants) {
  const n = Math.floor(Number(numParticipants));
  if (!Number.isFinite(n) || n < 2) return 0;
  return n - 1;
}

export function opponentPlaceholder(index) {
  return `Avversario ${index + 1}`;
}

function newOpponentId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `opp_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * @param {{ id: string, name: string }[]} opponents
 * @param {number|null|undefined} numParticipants
 * @returns {{ id: string, name: string }[]}
 */
export function syncOpponentSlots(opponents, numParticipants) {
  const need = opponentSlotsNeeded(numParticipants);
  const list = Array.isArray(opponents)
    ? opponents.map((o) => ({
      id: String(o?.id || '').trim() || newOpponentId(),
      name: String(o?.name ?? ''),
    }))
    : [];
  while (list.length < need) {
    list.push({ id: newOpponentId(), name: '' });
  }
  return list.slice(0, need);
}

/**
 * Legge i campi nome dal form Impostazioni (data-opp-id).
 * @param {ParentNode} root
 * @param {{ id: string, name: string }[]} fallback
 */
export function readOpponentNamesFromForm(root, fallback = []) {
  const inputs = root?.querySelectorAll?.('[data-opp-id]');
  if (!inputs?.length) {
    return (fallback || []).map((o) => ({ id: o.id, name: String(o.name ?? '') }));
  }
  return Array.from(inputs).map((el) => ({
    id: el.getAttribute('data-opp-id') || newOpponentId(),
    name: String(el.value ?? ''),
  }));
}
